import { render, staticRenderFns } from "./CreatePlatformModal.vue?vue&type=template&id=7a71a534"
import script from "./CreatePlatformModal.vue?vue&type=script&lang=js"
export * from "./CreatePlatformModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports